import { useAuthContext } from '~/providers/AuthProvider';
import { useCallback, useMemo } from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { setUserProfile } from '~/store/currentUser';
import { signOutRequest } from '../api/auth/singOutRequest';
export function useAuth() {
    const queryClient = useQueryClient();
    const [{ token }, authActions, { initializeInterceptors }] = useAuthContext();
    const dispatch = useDispatch();
    const userProfile = useSelector((state) => state.currentUser.profile);
    const setUserProfileAction = useCallback((profile) => {
        dispatch(setUserProfile(profile));
    }, [dispatch]);
    const signOut = useCallback(async () => {
        await signOutRequest();
        authActions.signOut();
        dispatch(setUserProfile(null));
        queryClient.clear();
    }, [dispatch, authActions, queryClient]);
    const status = useMemo(() => {
        if (!token) {
            return 'logged-out';
        }
        if (!userProfile) {
            return 'fetching';
        }
        return 'active';
    }, [token, userProfile]);
    return {
        signIn: authActions.signIn,
        signOut,
        userProfile,
        setUserProfile: setUserProfileAction,
        initializeInterceptors,
        token,
        status,
    };
}
